import type { DocumentInstanceRead } from '@/services/api/generated/hipaaESignService';

const SATISFIED_HIPAA_ESIGN_STATUSES: ReadonlySet<DocumentInstanceRead['status']> =
  new Set(['SIGNED', 'COMPLETED']);

export const hasSatisfiedHipaaSignatureRequirement = ({
  hasUploadedSignatureImage,
  hasSignedAuthorizationMerge,
  eSignStatus,
}: {
  hasUploadedSignatureImage: boolean;
  hasSignedAuthorizationMerge: boolean;
  eSignStatus?: Pick<DocumentInstanceRead, 'status'> | null;
}): boolean =>
  hasUploadedSignatureImage ||
  hasSignedAuthorizationMerge ||
  Boolean(
    eSignStatus &&
      SATISFIED_HIPAA_ESIGN_STATUSES.has(eSignStatus.status),
  );
